export default __webpack_public_path__ + "static/signature-a8b868f4a3fff7597f3f9a65f791390a.png";